import { render, staticRenderFns } from "./NoSidebars.vue?vue&type=template&id=31488c7a"
import script from "./NoSidebars.vue?vue&type=script&lang=ts"
export * from "./NoSidebars.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports